import { render } from "./ModalShowProductList.vue?vue&type=template&id=4166b708&scoped=true"
import script from "./ModalShowProductList.vue?vue&type=script&lang=js"
export * from "./ModalShowProductList.vue?vue&type=script&lang=js"

import "./ModalShowProductList.vue?vue&type=style&index=0&id=4166b708&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4166b708"]])

export default __exports__